import './HomePage.scss';
import React, { useEffect } from 'react';
import { Breadcrumb, ConfigProvider } from 'antd';
import EventsTile from './Tiles/EventsTile';
import LabelsTile from './Tiles/LabelsTile';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAccessPointData, fetchLabelData } from '../../slices/homeSlice';
import { fetchEvents } from '../../slices/eventSlice';
import { fetchLocations } from '../../slices/locationSlice';

const HomePage = () => {
  const root = document.documentElement;
  const dispatch = useDispatch();
  const primaryColor = getComputedStyle(root)
    .getPropertyValue('--primary-color')
    .trim();

  const labelData = useSelector(state => state.home.labelData);
  const labelStatus = useSelector(state => state.home.labelStatus);

  const accessPointData = useSelector(state => state.home.accessPointData);
  const apStatus = useSelector(state => state.home.accessPointStatus);

  const eventData = useSelector(state => state.events.data);
  const eventStatus = useSelector(state => state.events.status);

  const locationData = useSelector(state => state.locations.data);
  const locationsStatus = useSelector(state => state.locations.status);

  useEffect(() => {
    if (labelStatus === 'idle') {
      dispatch(fetchLabelData());
    }
  }, [labelStatus, dispatch]);

  useEffect(() => {
    if (apStatus === 'idle') {
      dispatch(fetchAccessPointData());
    }
  }, [apStatus, dispatch]);

  useEffect(() => {
    if (eventStatus === 'idle') {
      dispatch(fetchEvents());
    }
  }, [eventStatus, dispatch]);

  useEffect(() => {
    if (locationsStatus === 'idle') {
      dispatch(fetchLocations());
    }
  }, [locationsStatus, dispatch]);

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: primaryColor
        },
        components: {
          Typography: {
            titleMarginTop: '0.5em'
          }
        }
      }}
    >
      <div style={{ padding: '0px 12px 12px 12px' }}>
        <Breadcrumb></Breadcrumb>
        <div style={{ marginBottom: '12px' }}>
          {/*<RangePicker showTime />*/}
        </div>
        <div className="container-tiles">
          <div className="flex-col" style={{ width: '100%', flexGrow: 1 }}>
            <EventsTile
              data={eventData}
              locationData={locationData}
            />
            <LabelsTile
              data={labelData}
              accessPointData={accessPointData}
            />
          </div>
          {/*<div className="flex-col" style={{ width: '70%', flexGrow: 1 }}>*/}
          {/*  <JobsTile></JobsTile>*/}
          {/*</div>*/}
        </div>
      </div>
    </ConfigProvider>
  );
};

export default HomePage;
